var map = {
	"./auth.js": "CAWO",
	"./lang.js": "a6dv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9Az";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/store/modules nonrecursive .*\.js$
// module id = d9Az
// module chunks = 12